// teamMemberConstants.js

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassFullOutlinedIcon from "@mui/icons-material/HourglassFullOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import { ORG_ADMIN, ORG_STANDARD_USER, ORG_SUPER_ADMIN } from "./Roles";

// Role mappings for display
export const roleMapping = {
  OWNER: "Owner",
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  STANDARD_USER: "Standard User",
};

// Status mappings for display
export const statusMapping = {
  ACCEPTED: "Active",
  INVITED: "Pending",
  REJECTED: "Rejected",
};

// Dropdown options for role selection
export const dropdownOptionsSuperAdmin = [
  {
    label: "Super Admin",
    value: "SUPER_ADMIN",
    roleId: ORG_SUPER_ADMIN.roleId,
  },
  { label: "Admin", value: "ADMIN", roleId: ORG_ADMIN.roleId },
  { label: "User", value: "STANDARD_USER", roleId: ORG_STANDARD_USER.roleId },
];

export const dropdownOptionsAdmin = [
  { label: "Admin", value: "ADMIN", roleId: ORG_ADMIN.roleId },
  { label: "User", value: "STANDARD_USER", roleId: ORG_STANDARD_USER.roleId },
];

// Status configuration for icons and colors
export const statusConfig = {
  active: {
    label: "Active",
    icon: <CheckCircleIcon />,
    color: "#2AC078",
  },
  pending: {
    label: "Pending",
    icon: <HourglassFullOutlinedIcon />,
    color: "#ffa500",
  },
  rejected: {
    label: "Rejected",
    icon: <CancelIcon />,
    color: "#ff0000",
  },
};
